
import { useEffect } from 'react';
import Navbar from '@/components/homepage/Navbar';
import Footer from '@/components/homepage/Footer';
import StrategiesHero from '@/components/homepage/strategies/StrategiesHero';
import StrategyShowcase from '@/components/homepage/strategies/StrategyShowcase';
import StrategyBond from '@/components/homepage/strategies/StrategyBond';

const Strategies = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-900">
      <Navbar />
      <main className="flex-grow">
        <StrategiesHero />
        <StrategyShowcase />
        {/* DO NOT DELETE - HIDDEN FOR NOW*/}
        {/* <StrategyBond /> */}
      </main>
      <Footer />
    </div>
  );
};

export default Strategies;
